import { getAllFeild } from "../../api/categoryFeild/index.js";
/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Paper } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";

import Filters from "../../../../shared/ui/filters/index.jsx";
import { EDIT_CATEGORY_FEILD_ACTIVE, EXPORT_CATEGORY_FEILD, GET_ALL_CATEGORY_FEILD, GET_ALL_MAIN_CATEGORY_FEILD } from "../../../../shared/api/endpoints.js";

import CategoryFeilds from "./modal.jsx";

const CategoriesFeild = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { token } = useSelector((state) => state.user);

  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [feilds, setFeilds] = useState([]);

  const [sort, setSort] = useState({});
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshData, setRefresh] = useState(0);
  const { id } = useParams();
  const [filterApplied, setFilterApplied] = useState([]);

  useLayoutEffect(() => {
    var temp = filter;
    temp.push({
      name: "categoryId",
      value: id,
      type: "eq",
    });
    setFilterApplied(temp);
  }, [filter]);
  const { hasMore, loading, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      searchParams.get("isParent") === "true"
        ? GET_ALL_MAIN_CATEGORY_FEILD
        : GET_ALL_CATEGORY_FEILD,
      filterApplied,
      true,
      refreshData,
      sumbitSearch
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);
  useEffect(() => {
    getAllFeild(token)
      .then((res) => {
        const { data } = res;
        setFeilds(data?.data);
      })
      .catch((err) => {
        /*    if (err.response.status === 401) {
          dispatch(logout());
        } */
      });
  }, []);
  return (
    <>
      <PageTitle
        title={"فیلد های دسته بندی" + " " +searchParams.get("title")}
        broadCrumb={[
          {
            title: " مدریت دسته بندی",
            path: "/category",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
             
                <Exports
                  sumbitSearch={sumbitSearch}
                  filter={filter}
                  header={header}
                  data={allData}
                  selectedData={selected}
                  title=" فیلد های دسته بندی"
                  api={EXPORT_CATEGORY_FEILD}
                />
         

              <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن فیلد  دسته بندی جدید
              </Button>
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_CATEGORY_FEILD_ACTIVE}
          title={"فیلد های دسته بندی" + " " +searchParams.get("title")}
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"دسته بندی "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <CategoryFeilds
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
        feilds={feilds}
      />
    </>
  );
};

export default CategoriesFeild;
